"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertMessage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("../../../assets/icons"));
var CopyTooltip_1 = require("../../atoms/CopyTooltip/CopyTooltip");
var Icon_1 = require("../../atoms/Icon/Icon");
var TextIcon_1 = require("../../atoms/TextIcon/TextIcon");
var Typography_1 = require("../../atoms/Typography/Typography");
var AlertMessage_static_1 = require("./AlertMessage.static");
var AlertMessage_style_1 = __importDefault(require("./AlertMessage.style"));
/**
 * AlertMessage molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-alertmessage--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/AlertMessage Source}
 */
var AlertMessage = function (_a) {
    var className = _a.className, icon = _a.icon, title = _a.title, message = _a.message, _b = _a.variant, variant = _b === void 0 ? 'error' : _b, _c = _a.maxHeight, maxHeight = _c === void 0 ? 200 : _c, endAdornment = _a.endAdornment, hasCopyAction = _a.hasCopyAction;
    var classes = (0, AlertMessage_style_1.default)(maxHeight);
    if (!title && !message) {
        return null;
    }
    var withoutAction = !endAdornment && !hasCopyAction;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, variant === 'warning' && classes.warning, variant === 'info' && classes.info, withoutAction && classes.rootWithoutAction, className) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.flexContainer, classes.maxHeight) }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { color: AlertMessage_static_1.iconColorVariants[variant], iconPath: icon || AlertMessage_static_1.iconVariants[variant] }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.flexContainer, 'errorInfo') }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [title && renderTitle(), message && renderMessage()] }) })), !withoutAction && renderAction()] })));
    function renderTitle() {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: message ? classes.titleContainer : undefined }, { children: typeof title === 'string' ? ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: 'title', variant: 'headline3' }, { children: title }))) : (title) })));
    }
    function renderMessage() {
        if (typeof message === 'string') {
            return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: 'message', breakWord: true }, { children: message })));
        }
        return message;
    }
    function renderAction() {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.flexContainer, classes.maxHeight, 'textIconContainer') }, { children: [endAdornment, hasCopyAction && message && typeof message === 'string' && ((0, jsx_runtime_1.jsx)(CopyTooltip_1.CopyTooltip, __assign({ label: AlertMessage_static_1.localText.content, textToCopy: message, hideText: true }, { children: (0, jsx_runtime_1.jsx)(TextIcon_1.TextIcon, { bold: true, className: classes.copyIcon, icon: icons_1.default.clipboard, text: AlertMessage_static_1.localText.copy }) })))] })));
    }
};
exports.AlertMessage = AlertMessage;
